// import { postData } from "../common/Apicall";

// export const isVerifiedSellerApi = (storeID) => {
//   return postData("/api/v1/store/isVerifiedSeller", { storeID });
// };

import { postData } from "../common/Apicall";

export const isVerifiedSellerApi = (storeID) => {
  return postData("/api/v1/store/isVerifiedSeller");
};

export const gstDocumentSubmitApi = (blob) => {
  const formData = new FormData();
  formData.append("gst", blob);
  return postData("/api/v1/store/uploadGST", formData, true);
};

export const aadharDocumentSubmitApi = (blob) => {
  const formData = new FormData();
  formData.append("aadhar", blob);
  return postData("/api/v1/store/uploadAadhar", formData, true);
};

export const passportDocumentSubmitApi = (blob) => {
  const formData = new FormData();
  formData.append("passport", blob);
  return postData("/api/v1/store/uploadPassport", formData, true);
};

export const dlDocumentSubmitApi = (blob) => {
  const formData = new FormData();
  formData.append("dl", blob);
  return postData("/api/v1/store/uploadDL", formData, true);
};

export const addSellerTypeApi = (sellerType) => {
  return postData("/api/v1/store/addSellerType", { sellerType });
};

export const searchStoreByStringApi = (storeName) => {
  return postData("/api/v1/store/searchStoreByString", { storeName });
};

export const getStoresApi = (storeID) => {
  return postData("/api/v1/store/getStoreDetails", {
    storeID,
  });
};
